import { lazy } from 'react';
import { createBrowserRouter, Navigate, useLocation } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import PluginRoutes from './PluginRoutes';
import BackupRoutes from "./BackupRoutes"
import {TARGET_APP_BUILD_VALUE, TARGET_APP_BUILD} from "@/constants/globalConstants";
import {getSubRoot} from "@/utils/utils";

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));

// ==============================|| ROUTING RENDER ||============================== //

function NotFoundRedirect() {
    const { pathname } = useLocation();
    const notFoundPath = `${getSubRoot(pathname)}/maintenance/404`;

    if (pathname.replace(/\/+$/, '') === notFoundPath) {
        return <MaintenanceError />;
    }

    return <Navigate to={notFoundPath} replace />;
}

const routes = [LoginRoutes]
if (TARGET_APP_BUILD === TARGET_APP_BUILD_VALUE.BACKUP) {
    routes.push(BackupRoutes)
}else{
    routes.push(...[MainRoutes, PluginRoutes])
}
routes.push({ path: '*', element: <NotFoundRedirect /> })

const router = createBrowserRouter(routes, { basename: import.meta.env.VITE_APP_BASE_NAME });

export default router;
